import React from 'react';

import { di } from 'react-magnetic-di';

import type { Payload } from '@atlaskit/rovo-triggers/types';
import type { ActionKeys } from '@atlassian/conversation-assistant-message-actions-api/constants';
import type { ActionRendererFor } from '@atlassian/conversation-assistant-message-actions-api/types';

import { UpdateAgentBase } from '../update-agent-base';

export const StudioWorkspaceUpdateAgentDraftAction = (
	actionRenderer: ActionRendererFor<typeof ActionKeys.StudioWorkspaceUpdateAgentDraft>,
): React.JSX.Element => {
	di();

	const { buildId, draftContent } = actionRenderer.actions[0].data;
	const payload: Payload = {
		type: 'solution-draft-agent-update',
		data: {
			buildId,
			draftContent,
		},
		source: 'update-agent-draft-action-ui',
	};

	return <UpdateAgentBase actionRenderer={actionRenderer} payload={payload} />;
};
